import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import {
    PQR_RECEPTION_CHANNEL,
    PQR_RECEPTION_CHANNEL_DETAIL,
} from '../../../../../routes/paths';
import {
    asyncGetParam,
    asyncGetPqrReceptionChannelHistorical,
    asyncPatchPqrReceptionChannelParam,
    asyncPostPqrReceptionChannelParam,
} from '../../../../../services/param.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { Param, ParamHistorical } from '../../../../../shared/types/param';

export const usePqrReceptionChannelForm = () => {
    const navigate = useNavigate();
    const { idReceptionChannel } = useParams();
    const [pqrReceptionChannel, setPqrReceptionChannel] = useState<Param>();
    const [loading, setLoading] = useState(false);
    const [formikPqrReceptionChannelData, setFormikPqrReceptionChannelData] =
        useState<FormikProps<Param>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [pqrReceptionChannelHistorical, setPqrReceptionChannelHistorical] =
        useState<ParamHistorical[]>();

    const isValidForm = formikPqrReceptionChannelData?.isValid;

    const handleCleanAndBack = () => {
        formikPqrReceptionChannelData?.resetForm();
        navigate(PQR_RECEPTION_CHANNEL);
    };

    const handleSubmit = async () => {
        await formikPqrReceptionChannelData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Param = formikPqrReceptionChannelData?.values;

        let res: any | undefined = undefined;

        try {
            if (pqrReceptionChannel && pqrReceptionChannel.id)
                res = await asyncPatchPqrReceptionChannelParam(
                    pqrReceptionChannel.id,
                    data
                );
            else res = await asyncPostPqrReceptionChannelParam(data);
        } catch (error) {}
        if (res?.items) {
            const item = Array.isArray(res?.items) ? res?.items[0] : res?.items;
            ToastSwal.fire({
                text: `¡Felicidades! el canal de recepción se ${
                    pqrReceptionChannel && pqrReceptionChannel.id
                        ? 'actualizo'
                        : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${PQR_RECEPTION_CHANNEL_DETAIL}/${item.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    pqrReceptionChannel && pqrReceptionChannel.id
                        ? 'actualizar'
                        : 'crear'
                } el canal de recepción. Por favor, asegúrate de ${
                    pqrReceptionChannel && pqrReceptionChannel.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idReceptionChannel)) {
            setLoading(true);
            asyncGetParam(idReceptionChannel)
                .then((pqrReceptionChannel: any) => {
                    if (!pqrReceptionChannel || !pqrReceptionChannel.items)
                        navigate(PQR_RECEPTION_CHANNEL);
                    setPqrReceptionChannel(pqrReceptionChannel?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idReceptionChannel]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetPqrReceptionChannelHistorical(idReceptionChannel)
                .then((resp) => {
                    if (resp) setPqrReceptionChannelHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        pqrReceptionChannel,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikPqrReceptionChannelData,
        pqrReceptionChannelHistorical,
        showHistorical,
        setShowHistorical,
    };
};
